<template>
  <div class="header-wrapper">
    <!-- Modal Login -->
    <b-modal
        id="login-modal"
        v-model="showLogin"
        hide-footer
        hide-header
        centered
        content-class="apple-modal-content"
    >
      <div class="mt-2">
        <Login @close="showLogin = false" />
      </div>
    </b-modal>

    <!-- Header Apple Style -->
    <header
        v-show="showNavbar"
        class="apple-header"
    >
      <b-container>
        <b-navbar toggleable="md" type="light" class="p-0">
          <!-- Logo -->
          <b-navbar-brand href="/" class="brand-container">
            <b-img :src="logoPath" fluid width="130" alt="Coressy"></b-img>
          </b-navbar-brand>

          <!-- Toggle pentru mobil -->
          <b-navbar-toggle target="nav_collapse" class="custom-toggler"></b-navbar-toggle>

          <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav class="ml-auto align-items-center">

              <!-- Badge Membership Soon -->
              <li class="nav-item my-1 my-md-0">
                <span class="badge-soon">Membership Soon</span>
              </li>

              <!-- Link Orase -->
              <b-nav-item right class="apple-nav-item">
                <router-link :to="{ name: 'public.cities' }" class="nav-link-custom">
                  Orașe
                </router-link>
              </b-nav-item>

              <!-- Administrare dupa Roluri -->
              <b-nav-item right v-if="userInfo !== null && userInfo.role === 'administrator'" class="apple-nav-item">
                <router-link :to="{ name: 'admin.dashboard' }" class="nav-link-custom">
                  Administrare
                </router-link>
              </b-nav-item>

              <b-nav-item right v-if="userInfo !== null && userInfo.role === 'city-manager'" class="apple-nav-item">
                <router-link :to="{ name: 'city-manager.dashboard' }" class="nav-link-custom">
                  Administrare
                </router-link>
              </b-nav-item>

              <b-nav-item right v-if="userInfo !== null && userInfo.role === 'restaurant-manager'" class="apple-nav-item">
                <router-link :to="{ name: 'restaurant-manager.dashboard' }" class="nav-link-custom">
                  Administrare
                </router-link>
              </b-nav-item>

              <b-nav-item right v-if="userInfo !== null && userInfo.role === 'driver'" class="apple-nav-item">
                <router-link :to="{ name: 'driver.dashboard' }" class="nav-link-custom">
                  Administrare
                </router-link>
              </b-nav-item>

              <!-- Comenzi -->
              <b-nav-item right v-if="(userInfo !== null && userInfo.role === 'customer') || (userInfo !== null && userInfo.role === 'driver')" class="apple-nav-item">
                <router-link :to="{ name: 'customer.orders' }" class="nav-link-custom">
                  Comenzile mele
                </router-link>
              </b-nav-item>

              <!-- Auth Action Button -->
              <li class="nav-item ml-md-2 mt-2 mt-md-0">
                <button v-if="userInfo === null" @click="showLogin = true" class="btn-apple-nav">
                  Autentificare
                </button>
                <button v-else @click="logout" class="btn-apple-nav btn-secondary-apple">
                  Ieșire
                </button>
              </li>

            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </b-container>
    </header>
  </div>
</template>

<script>
import Login from '@/views/System/Login'
import Auth from '@/components/auth'
import { bus } from "../../main";

export default {
  name: "HeaderNav",
  data() {
    return {
      showLogin: false,
      showNavbar: true,
      userInfo: Auth.userInfo(),
      logoPath: process.env.VUE_APP_LOGO_PATH
    }
  },
  watch: {
    showLogin() {
      this.showNavbar = !this.showLogin;
    }
  },
  methods: {
    logout() {
      Auth.logout()
    }
  },
  components: {
    Login
  },
  mounted() {
    bus.$on('loggedIn', data => {
      this.userInfo = data
    })
    bus.$on('loggedOut', data => {
      this.userInfo = null
    })
    bus.$on('showLogin', data => {
      this.showLogin = true
    })
  }
}
</script>

<style scoped>
/* Apple Translucent Header Style */
.apple-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1030 !important;
  background-color: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 8px 0;
  transition: background-color 0.3s ease;
}

/* Align Brand Logo */
.brand-container {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

/* Nav Item Links */
.nav-link-custom {
  color: #1d1d1f !important;
  font-size: 0.88rem;
  font-weight: 400;
  letter-spacing: -0.01em;
  padding: 6px 12px;
  text-decoration: none !important;
  transition: opacity 0.2s ease, color 0.2s ease;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif;
}

.nav-link-custom:hover {
  color: #0071e3 !important;
  opacity: 0.8;
}

/* Badge 'Membership Soon' minimal */
.badge-soon {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #86868b;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  padding: 4px 10px;
  margin-right: 8px;
  display: inline-block;
  user-select: none;
}

/* Buton stilizat Apple */
.btn-apple-nav {
  background-color: #0071e3;
  color: #ffffff;
  border: none;
  border-radius: 980px; /* Pill button Apple */
  padding: 6px 16px;
  font-size: 0.85rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}

.btn-apple-nav:hover {
  background-color: #0077ed;
  box-shadow: 0 2px 8px rgba(0, 113, 227, 0.25);
}

.btn-apple-nav:active {
  transform: scale(0.97);
}

.btn-secondary-apple {
  background-color: #e8e8ed;
  color: #1d1d1f;
}

.btn-secondary-apple:hover {
  background-color: #d2d2d7;
  box-shadow: none;
}

/* Custom Mobile Toggler */
.custom-toggler {
  border: none !important;
  outline: none !important;
  padding: 4px 8px;
}

/* Modal Rounding */
::v-deep .apple-modal-content {
  border-radius: 18px !important;
  border: none !important;
  box-shadow: 0 20px 40px rgba(0,0,0,0.15) !important;
  overflow: hidden;
}
</style>
